import { useEffect, useMemo } from 'react';
import styles from './PreviewContentModal.module.css';
import { Select, Spin } from 'antd';
import PreviewModal from './PreviewModal';
import { useParams, useSearchParams } from "react-router-dom";
import { useRequest } from 'ahooks';
import { PreviewToken } from './Service/MediaMakerService';


const Preview = () => {
  const showFrom = true;

  const { token } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const apiDomain = searchParams.get("apiDomain");
  const versions = (searchParams.get("versions") || "V1").split(",").map((item)=>({
    value: item.slice(1),
    label: item,
  }));
  let requestVersion = String(searchParams.get("version"));
  if (!versions?.filter((item)=>item.value===`${requestVersion}`)?.length){
    requestVersion = versions[0]?.value;
  }

  const defaultVersion = requestVersion || versions[0]?.value || "1";

  const previewLogo = searchParams.get("preview_logo");
  useEffect(() => {
    if (previewLogo?.length) {
      const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = previewLogo;
      document.head.appendChild(link);
    }
  }, [previewLogo]);

  const { run: runPreviewToken, loading: runPreviewTokenLoading, data: runPreviewTokenData } = useRequest(PreviewToken, {
    manual: true, 
    onError: (err)=>{
      console.error(err.message);
    }
  });
  
  useEffect(()=>{
    runPreviewToken(apiDomain, token, searchParams.get("request_url"), defaultVersion);
  },[]);

  const renderedVersion = useMemo(()=>{
    return <Select style={{width: 100, marginLeft: 'auto' }} value={versions?.filter((item)=>item.value===`${defaultVersion}`)[0]?.label} onChange={(version)=>{
      searchParams.set("version", version);
      setSearchParams(searchParams); // 更新 URL 参数
      window.location.reload();
    }}>
        {
            (versions || []).map((choice, idx) => {
              return (
                <Select.Option key={idx} value={choice.value}>
                  {choice.label}
                </Select.Option>
              );
            })
          }
        </Select>
  },[defaultVersion, versions]);

  if (runPreviewTokenLoading)
    return (
      <Spin
        spinning
        style={{ position: "fixed", top: "30%", bottom: 0, right: 0, left: 0 }}
      />
    );

  if (!runPreviewTokenData || !runPreviewTokenData?.preview_subject){
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#f3f4f6", textAlign: "center" }}>
      <div style={{ backgroundColor: "white", padding: "24px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#dc2626" }}>Content Preview Expired</h2>
        <p style={{ color: "#4b5563", marginTop: "8px" }}>The current content preview has expired. Please execute the preview again.</p>
      </div>
    </div>
    )
  }

  return (
    <div className={styles.container}>
      <div style={{
          alignItems: "center",
          paddingTop: "1.5rem",
          paddingBottom: "1.5rem",
          width: "992px",
          margin: "0 auto"
        }}>
        <div style={{ display: "flex", alignItems: "center", paddingLeft: "1.5rem", paddingRight: "1.5rem" }}>
          <span>Subject: <b>[Sample] {runPreviewTokenData?.preview_subject}</b></span>
          {renderedVersion}
        </div>
        {showFrom && (
          <div style={{ display: "flex", alignItems: "center", paddingLeft: "1.5rem", paddingRight: "1.5rem", height: "32px"}}>
            <span> From: <b>{`${runPreviewTokenData?.from_name} <${runPreviewTokenData?.from_email}>`}</b></span>
          </div>
        )}
        {runPreviewTokenData?.reply_to && (
          <div style={{ display: "flex", alignItems: "center", paddingLeft: "1.5rem", paddingRight: "1.5rem", height: "32px"}} >
            <span>Reply To: <b>{runPreviewTokenData?.reply_to?.map(item => (<>{`${item.name}<${item.email}>; `}</>))}</b></span>
          </div>
        )}
        {runPreviewTokenData?.preview_text && (
          <div style={{ display: "flex", alignItems: "center", paddingLeft: "1.5rem", paddingRight: "1.5rem", height: "32px"}} >
            <span>Preview Text: <b>{runPreviewTokenData?.preview_text}</b></span>
          </div>
        )}
        {runPreviewTokenData?.attachments?.files && (
          <div style={{ display: "flex", alignItems: "center", paddingLeft: "1.5rem", paddingRight: "1.5rem", height: "32px"}} >
            <span>Attachment: <b>{runPreviewTokenData?.attachments?.files?.map(item => <>{item?.name}; </>)}</b></span>
          </div>
        )}
      </div>
      <PreviewModal html_file={runPreviewTokenData?.preview_content} disable_links={false}/>
    </div>
  );
};

export default Preview;